export type TransactionalCreditConfigurations = {
  isAllowed: boolean
}

export const defaultTransactionalCreditConfig: TransactionalCreditConfigurations = {
  isAllowed: false,
}